"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTheme = void 0;
var defaultTheme_1 = __importDefault(require("./defaultTheme"));
exports.defaultTheme = defaultTheme_1.default;
//# sourceMappingURL=index.js.map